import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { MaxValueLabel, MinValueLabel, SliderC, SliderWrapper } from '~/pages/Dairy/Survey/ShowSurvey/CreateEditQuestion/QuestionForms/Slider';
import { formatNumberWithoutFractions } from '~/utils/helpers';

interface SliderProps {
  control: any
  question: any
  setValue: any
  activeIndex: string | number
  getValues: any
}

const Slider: React.FC<SliderProps> = (props) => {
  const { control, setValue, question, activeIndex, getValues } = props
  const { t } = useTranslation()
  const [rating, setRating] = useState(0);

  useEffect(() => {
    const value = getValues(`questions[${activeIndex}].answers[0].value`)
    if (value) {
      setRating(value)
    }
  }, [props])

  const handleChange = (event) => {
    setRating(event.target.value);
    setValue(`questions[${activeIndex}].answers[0].value`, event.target.value)
  };

  return <FormFields.External
    control={control}
    rules={{
      required: question?.required ? t('Please move slider') : null
    }}
    label={question?.question}
    placeholder={question?.placeholder}
    name={`questions[${activeIndex}].answers[0].value`}
  >
    <>
      <Form.Field label={t('Rating: {{rating}} {{watchUnit}}',
        { rating: formatNumberWithoutFractions(rating), watchUnit: question?.unitLabel || '' })} />
      <SliderWrapper>
        <MinValueLabel>{`${formatNumberWithoutFractions(question?.minValue)} ${question?.unitLabel || ''}`}</MinValueLabel>
        <SliderC
          step={question?.interval}
          rating={((rating - question?.minValue) / (question?.maxValue - question?.minValue)) * 100}
          min={question?.minValue}
          max={question?.maxValue}
          value={rating}
          onChange={(e) => handleChange(e)}
        />
        <MaxValueLabel>{`${formatNumberWithoutFractions(question?.maxValue)} ${question?.unitLabel || ''}`}</MaxValueLabel>
      </SliderWrapper>
    </>
  </FormFields.External>
}
export default Slider